﻿$.fn.dxCtrlContentEmailEnvoi = function custom_dxCtrlContentEmailEnvoi(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentemailenvoi dx-ctrl");
        this.createInstance(new cdxCtrlContentEmailEnvoi(this, option));
    }
    return this;
}

window.cdxCtrlContentEmailEnvoi = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    var $DivResume = null
    var $DivEntete = null
    var $DivDest = null
    this.isDirty = function (value) {
        if (typeof value != 'undefined') dxContentEmailBase.isDirty(value)
        return dxContentEmailBase.isDirty(value)
    }

    var $DivBody = null
    var dxContentEmailEnvoiNormalTracking = null
    function mConstruit() {
        container.empty()
        if (container.closest("body").length == 0) return

        jauge = null
        if (container.closest(".dx-popup-normal").length > 0) {
            jauge = $("<div/>").appendTo($(container.closest(".dx-popup-normal")[0])).dxCtrlJauge({}).dxCtrlJauge("instance")
        } else if (container.closest(".dx-ctrlpagepopupdiv").length > 0 && $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup != null) {
            jauge = $(container.closest(".dx-ctrlpagepopupdiv")[0]).getInstance().popup.jauge
        } else {
            jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        }
        //jauge = $("<div/>").appendTo(((container.closest(".dx-popup-normal").length > 0) ? $(container.closest(".dx-popup-normal")[0]) : ((container.closest(".dx-ctrlpagepopupdiv").length > 0) ? $(container.closest(".dx-ctrlpagepopupdiv")[0]) : container))).dxCtrlJauge({}).dxCtrlJauge("instance")
        //jauge.mShow();

        $DivBody = $("<div style='width:100%;padding:0;height:100%;'/>").appendTo(container)
        //if (!parametre.isMobile) $DivBody.css("margin-top", "5px")

        if (option.data.tracking == "1" &&
            option.data.id_type_classement >= 8 &&
            option.data.id_type_classement <= 13) {
            //email tracking en cours d'envoi ou envoyé en tracking
            jauge.mShow();
            //            option.bddCtrl.mAjaxCall({ command: "getdatas", nomtable: "lstcomdest", sql: "select * from com_destinataire where id_table_com=" + option.bddCtrl.getObjet(option.data).mGetTable().id_table + " and id_com=" + option.data.id_com_email_envoi }, function (data) {
            mRempliBt()
            if (parametre.isMobile) option.optionPopup.toolbar.element().appendTo($DivBody)
            mRempliDate()
            //if (typeof data.lstcomdest == 'undefined') data.lstcomdest = []
            //if (data.lstcomdest.length <= 1) {
            //    dxContentEmailEnvoiNormalTracking = $("<div/>").appendTo($DivBody).dxCtrlContentEmailEnvoiNormal({
            //        bddCtrl: option.bddCtrl,
            //        data: option.data,
            //        lstDestinataire: option.lstDestinataire,
            //        onRempliBt: function () {
            //            mRempliBt()
            //            mRempliDate()
            //        }
            //    }).dxCtrlContentEmailEnvoiNormal("instance")
            //    jauge.mHide();
            //} else {
            //    eleBtAnnuelEnvoi.hide()
            //    eleDateEnvoi.hide()
            //    dxContentEmailEnvoiNormalTracking = $("<div style='height:100%'/>").appendTo($DivBody).dxCtrlContentEnvoiTracking({
            //        bddCtrl: option.bddCtrl,
            //        data: option.data
            //    }).dxCtrlContentEnvoiTracking("instance")
            //    jauge.mHide();
            //}

            //eleBtAnnuelEnvoi.hide()
            eleDateEnvoi.hide()
            dxContentEmailEnvoiNormalTracking = $("<div style='height:100%'/>").appendTo($DivBody).dxCtrlContentEnvoiTracking({
                bddCtrl: option.bddCtrl,
                data: option.data
            }).dxCtrlContentEnvoiTracking("instance")
            jauge.mHide();
            if (parametre.isMobile) resizeObserver.mAdd(option.optionPopup.toolbar.element(), function () {
                dxContentEmailEnvoiNormalTracking.element().css("height", "calc(100% - " + option.optionPopup.toolbar.element().innerHeight() + "px)")
            })()
            //})
        } else {
            mRempliBt()
            if (parametre.isMobile) option.optionPopup.toolbar.element().appendTo($DivBody)
            mRempliDate()
            //eleBtAnnuelEnvoi.hide()
            //eleDateEnvoi.hide()
            if (option.data.presentation_mailing == "1") {
                dxContentEmailEnvoiNormalTracking = $("<div style='height:100%'/>").appendTo($DivBody).dxCtrlContentEnvoiMailing({
                    bddCtrl: option.bddCtrl,
                    jauge: jauge,
                    data: option.data,
                    type: "email",
                    showPrevi: true,
                    onChange: function () {
                        mRempliTaille()
                    }
                }).dxCtrlContentEnvoiMailing("instance")
            } else {
                dxContentEmailEnvoiNormalTracking = $("<div/>").appendTo($DivBody).dxCtrlContentEmailEnvoiNormal({
                    bddCtrl: option.bddCtrl,
                    data: option.data,
                    jauge: jauge,
                    lstDestinataire: option.lstDestinataire,
                    onRempliBt: function () {
                        mRempliBt()
                        mRempliDate()
                    },
                    onChangeExpediteur: function () {
                        mRempliBt()
                        mRempliDate()
                    },
                    onChange: function () {
                        mRempliTaille()
                        if (typeof option.optionPopup.popupPage != 'undefined' && option.data && option.data.objet) {
                            //on est sur desktop (pas de tab en mobile)
                            var tab = option.optionPopup.popupPage.mGetTab()
                            tab.mUpdateTextWithText(option.data.objet)
                        }
                    }
                }).dxCtrlContentEmailEnvoiNormal("instance")
            }
            if (parametre.isMobile) resizeObserver.mAdd(option.optionPopup.toolbar.element(), function () {
                dxContentEmailEnvoiNormalTracking.element().css("height", "calc(100% - " + option.optionPopup.toolbar.element().innerHeight() + "px)")
            })()
        }


    }

    //var eleBtAnnuelEnvoi = null
    var eleDateEnvoi = null
    var eleTaille = null
    var lstItemToolBarSource = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = $("<div/>").appendTo(container).dxToolbar({
                width: "100%",
                items: [],
                onContentReady: function (e) {
                    e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
                }
            }).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }

        var itemsToolbar = []



        if (parametre.isMobile) {
            itemsToolbar.push(getToolbarSeparator())
            itemsToolbar.push({
                location: 'before',
                locateInMenu: 'never',
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-xmark",
                        txtTooltip: "Fermer",
                        onClick: function (e) {
                            page.mRemovePopup(option.data)
                        }
                    });
                },
            })
        }

        //itemsToolbar.push({
        //    location: 'after',
        //    locateInMenu: 'auto',
        //    visible: !parametre.isMobile,
        //    template(itemData, itemIndex, itemElement) {
        //        eleBtAnnuelEnvoi = $("<div/>").appendTo(itemElement).dxCtrlButton({
        //            html: "<div style='font-size:70%;line-height:1;'>Annuler<br/>l'envoi</div>",
        //            width: 80,
        //            onClick: function (e) {
        //                option.data.date_envoi = null
        //                option.data.id_type_classement = 7
        //                option.bddCtrl.getObjet(option.data).mSave()
        //                page.mRemovePopup(option.data, function () {
        //                    option.bddCtrl.getObjet(option.data).mShowPopup()
        //                    window.setTimeout(function () { mNotify("L'envoi de votre email a été annulé.<br/>Celui-ci est maintenant dans vos brouillons.", "success", 4000) }, 1000)
        //                })
        //            }
        //        })
        //    },
        //})
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                eleDateEnvoi = $("<span style='font-size:100%;' title='" + "'>" + "</span>").appendTo(itemElement)
            },
        })
        itemsToolbar.push(getToolbarSeparator())

        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            visible: !parametre.isMobile,
            template(itemData, itemIndex, itemElement) {
                eleTaille = $("<span style='font-size:80%;' title='" + "'>" + "</span>").appendTo(itemElement)
            },
        })
        itemsToolbar.push(getToolbarSeparator())


        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            visible: !parametre.isMobile && option.bddCtrl.baseAppli.para.email.has_reception_email,
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-envelope",
                    hint: "Transférer à tous<br/><span style='opacity:0.5;'>Génère un email de transfert<br/>avec copie de tous les destinataires en A, CC et CCI</span>",
                    icon2: "fas fa-arrow-rotate-left",
                    //text: "Transférer à tous",
                    width: "100%",
                    onClick: function (e) {
                        jauge.mShow()
                        if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                            dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                                option.bddCtrl.getObjet(option.data).objetMetier.mShowTransfereATous(function () {
                                    jauge.mHide()
                                    page.mRemovePopup(option.data)
                                })
                            }, option.bddCtrl.getObjet(option.data).cle() == null)
                        } else {
                            option.bddCtrl.getObjet(option.data).objetMetier.mShowTransfereATous(function () {
                                jauge.mHide()
                                page.mRemovePopup(option.data)
                            })
                        }
                    },
                    onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                });
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: ((parametre.isMobile) ? "auto" : 'auto'),
            visible: option.bddCtrl.baseAppli.para.email.has_reception_email,
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-envelope",
                    txtTooltip: "Transférer",
                    icon2: "fas fa-share",
                    //text: ((parametre.isMobile) ? "" : "Transférer"),
                    width: "100%",
                    onClick: function (e) {
                        jauge.mShow()
                        if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                            dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                                option.bddCtrl.getObjet(option.data).objetMetier.mShowTransfere(function () {
                                    jauge.mHide()
                                    page.mRemovePopup(option.data)
                                })
                            }, option.bddCtrl.getObjet(option.data).cle() == null)
                        } else {
                            option.bddCtrl.getObjet(option.data).objetMetier.mShowTransfere(function () {
                                jauge.mHide()
                                page.mRemovePopup(option.data)
                            })
                        }
                    },
                    onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                });
            },
        })
        itemsToolbar.push(getToolbarSeparator("after", "auto"))
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            visible: !parametre.isMobile,
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-print",
                    txtTooltip: "Imprimer",
                    width: "100%",
                    onClick: function (e) {
                        jauge.mShow();
                        jauge.option("message", "Génération de l'impression")

                        if (option.data.id_com_email_envoi == null) {
                            if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                                dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () { mPrint() }, option.bddCtrl.getObjet(option.data).cle() == null)
                            } else { mPrint() }
                        } else { mPrint() }

                        function mPrint() {
                            option.bddCtrl.mAjaxCall({
                                command: "printemailenvoi",
                                id: option.data.id_com_email_envoi,
                                nom_table: "com_email_envoi"
                            }, function (data) {
                                if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                                $("<div/>").appendTo("body").dxCtrlViewer({
                                    bddCtrl: option.bddCtrl,
                                    value: [data.urlpdf],
                                    indexCourant: 0
                                })
                                jauge.mHide();
                            })
                        }
                    },
                    //onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                });
            },
        })
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            visible: !parametre.isMobile,
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-copy",
                    txtTooltip: "Dupliquer",
                    width: "100%",
                    onClick: function (e) {
                        if (!option.bddCtrl.objCptCli.objetMetier.hasEmail()) {
                            mNotify("Vous n'avez pas les emails dans votre offre", "error", 10000)
                            return
                        }
                        if (option.data.id_com_email_envoi == null) {
                            if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                                dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () { mLanceDuplik() }, option.bddCtrl.getObjet(option.data).cle() == null)
                            } else { mLanceDuplik() }
                        } else { mLanceDuplik() }

                        function mLanceDuplik() {
                            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                width: 400,
                                target: e.component.element(),
                                contentTemplate: function (contentElement) {
                                    contentElement.css("padding", "24px")
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Dupliquer sans destinataire",
                                        width: "100%",
                                        onClick: function (e) {
                                            mDuplik("0")
                                            tt.hide()
                                        }
                                    });
                                    $("<br/>").appendTo(contentElement)
                                    $("<div/>").appendTo(contentElement).dxCtrlButton({
                                        text: "Dupliquer avec destinataire",
                                        width: "100%",
                                        onClick: function (e) {
                                            mDuplik("1")
                                            tt.hide()
                                        }
                                    });
                                }
                            }).dxCtrlTooltip("instance");
                            tt.show();

                            function mDuplik(avecDestinataire) {
                                jaugeDemarrage.mShow()
                                option.bddCtrl.mAjaxCall({ command: "duplikemailenvoi", id_com_email_envoi: option.data.id_com_email_envoi, avec_destinataire: avecDestinataire }, function (data) {
                                    page.mAddPopup(option.bddCtrl.getObjet("com_email_envoi", data.id_com_email_envoi).data, { fullScreen: true })
                                    jaugeDemarrage.mHide()
                                })
                                page.mRemovePopup(option.data)
                            }

                        }
                    },
                    //onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                });
            },
        })
        if (option.data.date_envoi == null || option.data.id_type_classement == 11) {
            if (!parametre.isMobile) itemsToolbar.push(getToolbarSeparator("after", "auto"))

            if (option.data.presentation_mailing != "1") {
                //itemsToolbar.push({
                //    location: 'after',
                //    locateInMenu: 'always', //'auto',
                //    visible: !parametre.isMobile,
                //    template(itemData, itemIndex, itemElement) {
                //        var opt = {
                //            icon: "fas fa-paper-plane",
                //            icon2: "fas fa-cog",
                //            colorIcone2: theme.colorBtIcon2,
                //            opacityIcone2: "0.9",
                //            icon3: "fas fa-question",
                //            colorIcone3: theme.colorBtIcon3,
                //            txtTooltip: "Ouvrir la gestion des destinataires<br/>et la configuration d'envoi.",
                //            text: "Gestion destinataire",
                //            leftIcone3: true,
                //            width: "100%",
                //            onClick: function (e) {
                //                if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                //                    dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                //                        dxContentEmailEnvoiNormalTracking.mDisplayGestionAdresseEnvoi(function () {
                //                            dxContentEmailEnvoiNormalTracking.mSend(8)
                //                            page.mRemovePopup(option.data)
                //                        })
                //                    }, option.bddCtrl.getObjet(option.data).cle() == null)
                //                } else {
                //                    dxContentEmailEnvoiNormalTracking.mSend(8)
                //                    page.mRemovePopup(option.data)
                //                }
                //            },
                //            onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                //        }
                //        $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
                //    },
                //})
                itemsToolbar.push({
                    location: 'after',
                    locateInMenu: 'auto',
                    template(itemData, itemIndex, itemElement) {
                        var opt = {
                            icon: "fas fa-paper-plane",
                            txtTooltip: "Envoyer",
                            animate: false,
                            onClick: function (e) {
                                if (!option.bddCtrl.objCptCli.objetMetier.hasEmail()) {
                                    mNotify("Votre offre ne vous permets pas d'envoyer des emails", "error", 10000)
                                    return
                                }
                                if (option.bddCtrl.gestion_taille_base.can_send_can_receive_email == "0") {
                                    mNotify("La taille de votre environnement dépasse la limite de <b>" + option.bddCtrl.gestion_taille_base.max_taille + "Go</b>.<br/>Vous ne pouvez plus envoyer de mails.<br/><a href='javascript:void(0)'>Cliquez pour en savoir plus</a>", "warning", 10000, function () {
                                        $("<div/>").appendTo("body").dxCtrlTailleEnvironnement({
                                            bddCtrl: option.bddCtrl
                                        })
                                    })
                                    return
                                }
                                if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                                    dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                                        option.data.tracking = "0"
                                        option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () { })
                                        dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 8)
                                    }, option.bddCtrl.getObjet(option.data).cle() == null)
                                } else {
                                    option.data.tracking = "0"
                                    option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () { })
                                    dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 8)
                                }
                            }
                        }
                        var dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
                            return dataCpteEmail.id_compte_email == option.data.id_compte_email
                        })[0]
                        if (typeof dataCompteEmail != 'undefined' && dataCompteEmail.envoi_actif == "0") {
                            opt.icon2 = "fas fa-circle-exclamation"
                            opt.colorIcone2 = "red"
                            opt.opacityIcone2 = "0.6"
                            opt.txtTooltip = "Le SMTP de l'adresse email n'est pas actif<br/>Votre email sera envoyé via les serveurs de " + parametre.nom
                        }
                        $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
                    },
                })
                itemsToolbar.push({
                    location: 'after',
                    locateInMenu: 'auto',
                    template(itemData, itemIndex, itemElement) {
                        var opt = {
                            icon: "fas fa-paper-plane",
                            icon2: "fas fa-bullseye",
                            colorIcone2: theme.colorBtIcon2,
                            opacityIcone2: "0.9",
                            icon3: "fas fa-clock",
                            opacityIcone3: "0.7",
                            colorIcone3: theme.colorBtIcon2,
                            leftIcone3: true,
                            bottomIcone3: true,
                            txtTooltip: "Envoyer votre email en tracking et/ou définir une date d'envoi",
                            onClick: function (e) {
                                if (!option.bddCtrl.objCptCli.objetMetier.hasEmail()) {
                                    mNotify("Votre offre ne vous permets pas d'envoyer des emails", "error", 10000)
                                    return
                                }
                                if (option.bddCtrl.gestion_taille_base.can_send_can_receive_email == "0") {
                                    mNotify("La taille de votre environnement dépasse la limite de <b>" + option.bddCtrl.gestion_taille_base.max_taille + "Go</b>.<br/>Vous ne pouvez plus envoyer de mails.<br/><a href='javascript:void(0)'>Cliquez pour en savoir plus</a>", "warning", 10000, function () {
                                        $("<div/>").appendTo("body").dxCtrlTailleEnvironnement({
                                            bddCtrl: option.bddCtrl
                                        })
                                    })
                                    return
                                }

                                var pop = $("<div/>").appendTo("body").dxCtrlPopupBase({
                                    showMaximize: false,
                                    height: "auto",
                                    width: 650,
                                    hideOnOutsideClick: false,
                                    shading: true,
                                    title: "envoyer en tracking et/ou avec date d'envoi",
                                    contentTemplate: function (contentElement) {
                                        if (dxContentEmailEnvoiNormalTracking.mGetNbDestACCCCI() > 1) {
                                            $("<div style='font-weight:normal;text-align:left;'>Lorsque vous envoyez un email en tracking<br/>avec plusieurs destinataires,<br/>chaque personne <b>reçoit un email individuel</b> et personnalisé.</div>").appendTo(contentElement)
                                            $("<ul style='text-align:left;'>" +
                                                "<li>Chaque destinataire voit uniquement son propre nom et adresse,<br/>et <b>ne voit pas les autres destinataires</b>.</li>" +
                                                "<li>Cela signifie que l'email n'est pas envoyé en copie ou copie cachée (A, CC, CCI),<br/>mais bien en <b>envois distincts, un par destinataire</b>.</li>" +
                                                "<li>Si un destinataire clique sur 'Répondre' ou 'Répondre à tous',<br/>sa réponse ira uniquement à l'expéditeur (vous),<br/>et pas aux autres destinataires, puisqu'il n'en a pas connaissance.</li>" +
                                                "</ul>").appendTo(contentElement)
                                        }

                                        var dxChkTracking = $("<div style='margin:20px;display:block;'/>").appendTo(contentElement).dxCheckBox({
                                            text: "Envoyer avec tracking",
                                            hint:"Activer/désactiver le tracking",
                                            value: true
                                        }).dxCheckBox("instance")

                                        var dxChkDate = $("<div style='margin:20px;display:block;'/>").appendTo(contentElement).dxCheckBox({
                                            text: "Définir une date d'envoi (pour programmer le jour et l'heure ou votre email sera envoyé)",
                                            hint:"Tous vos emails dont la date d’envoi est programmée dans le futur se retrouveront dans les « Emails en attente d’envoi ».",
                                            value: false,
                                            onValueChanged: function (e) {
                                                if (e.value) { $DivDate.slideDown(300) }
                                                else { $DivDate.slideUp(300) }
                                            }
                                        }).dxCheckBox("instance")

                                        var date = new Date(parametre.dateNow);
                                        date.addHours(24);
                                        date.setHours(9, 0, 0, 0);
                                        var $DivDate = $("<div style='display:none;'/>").appendTo(contentElement)
                                        var $TableDate = $("<table/>").appendTo($DivDate)
                                        var $Tr = $("<tr/>").appendTo($TableDate)
                                        var $Td = $("<td style='width:50%;'>").appendTo($Tr)
                                        var dxDate = $('<div/>').appendTo($Td).dxCalendar({
                                            value: new Date(),
                                            disabled: false,
                                            firstDayOfWeek: 0,
                                            showWeekNumbers: false,
                                            weekNumberRule: 'auto',
                                            zoomLevel: 'month',
                                            min: (new Date(parametre.dateNow)).addMinutes(10),
                                            onValueChanged: function () {
                                                var date = new Date(dxDate.option("value"));
                                                date.setHours(dxHeure.option("value").replace("h", ""), 0, 0, 0);
                                                $DivResultDate.text("envoi " + date.toDateIlya() + " (" + date.toFrenchDateTime() + ")")
                                            }
                                        }).dxCalendar('instance');
                                        var $Td = $("<td style='width:50%;padding:30px 0 0 20px;'>").appendTo($Tr)
                                        var ds = ["6h", "7h", "8h", "9h", "10h", "11h", "12h", "13h", "14h", "15h", "16h", "17h", "18h", "19h", "20h", "21h","22h"]
                                        var dxHeure = $("<div/>").appendTo($Td).dxRadioGroup({
                                            dataSource: ds,
                                            value: "9h",
                                            layout: 'horizontal',
                                            onValueChanged: function () {
                                                var date = new Date(dxDate.option("value"));
                                                date.setHours(dxHeure.option("value").replace("h", ""), 0, 0, 0);
                                                $DivResultDate.text("envoi " + date.toDateIlya() + " (" + date.toFrenchDateTime() + ")")
                                            }
                                        }).dxRadioGroup("instance")
                                        var $DivResultDate = $("<div style='text-align:center'/>").appendTo($DivDate)
                                        $DivResultDate.text("envoi " + date.toDateIlya() + " (" + date.toFrenchDateTime() + ")")

                                        mAddButtonOkAnnuler(contentElement,
                                            function () { //ok
                                                if (dxChkDate.option("value")) {
                                                    var date = new Date(dxDate.option("value"));
                                                    date.setHours(dxHeure.option("value").replace("h",""), 0, 0, 0);
                                                    option.data.date_debut_envoi = date
                                                    option.data.ignore_attente_compte_email = "1"
                                                }
                                                if (dxChkTracking.option("value")) {
                                                    mSendTracking()
                                                } else {
                                                    if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                                                        dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                                                            option.data.tracking = "0"
                                                            option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () { })
                                                            dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 8)
                                                        }, option.bddCtrl.getObjet(option.data).cle() == null)
                                                    } else {
                                                        option.data.tracking = "0"
                                                        option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () { })
                                                        dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 8)
                                                    }
                                                }
                                                pop.hide();
                                            },
                                            function () { //annuler
                                                pop.hide();
                                            }, "Annuler", "Envoyer").table.css("margin-top", "20px")

                                    }
                                }).dxCtrlPopupBase("instance")
                                pop.show()

                                //var dataCompteEmail = option.bddCtrl.getObjet(option.bddCtrl.utiCourant).objetMetier.mGetLstDataCompteEmail().filter(function (dataCpteEmail) {
                                //    return dataCpteEmail.id_compte_email == option.data.id_compte_email
                                //})[0]
                                //if (typeof option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email] == 'undefined') {
                                //    option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email] = {}
                                //}
                                //if (typeof option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].envoi_tracking_prevenir == 'undefined') {
                                //    option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].envoi_tracking_prevenir = true
                                //}
                                //if (dxContentEmailEnvoiNormalTracking.mGetNbDestACCCCI() > 1 &&
                                //    option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].envoi_tracking_prevenir) {
                                //    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                                //        target: e.component.element(),
                                //        contentTemplate: function (contentElement) {
                                //            contentElement.css("padding", "25px")
                                //            contentElement.css("white-space", "normal")
                                //            contentElement.css("font-size", "110%")
                                //            contentElement.css("line-height", "1.4")
                                //            $("<div style='font-weight:normal;text-align:left;'>Lorsque vous envoyez un email en utilisant notre système<br/>avec plusieurs destinataires en tracking,<br/>chaque personne <b>reçoit un email individuel</b> et personnalisé.</div>").appendTo(contentElement)
                                //            $("<ul style='text-align:left;'>" +
                                //                "<li>Chaque destinataire voit uniquement son propre nom et adresse,<br/>et <b>ne voit pas les autres destinataires</b>.</li>" +
                                //                "<li>Cela signifie que l'email n'est pas envoyé en copie ou copie cachée (A, CC, CCI),<br/>mais bien <b>envois distincts, un par destinataire</b>.</li>" +
                                //                "<li>Si un destinataire clique sur 'Répondre' ou 'Répondre à tous',<br/>sa réponse ira uniquement à l'expéditeur (vous),<br/>et pas aux autres destinataires, puisqu'il n'en a pas connaissance.</li>" +
                                //                "</ul>").appendTo(contentElement)
                                //            $("<div style='margin:10px;'/>").appendTo(contentElement).dxCtrlButton({
                                //                html: "J'ai compris, envoyer en tracking",
                                //                width: "100%",
                                //                onClick: function (e) {
                                //                    mSendTracking()
                                //                    tt.hide()
                                //                }
                                //            })
                                //            $("<div style='margin:0 10px;'/>").appendTo(contentElement).dxCheckBox({
                                //                text: "Ne plus me prévenir de cela",
                                //                value: false,
                                //                onValueChanged: function (e) {
                                //                    option.bddCtrl.utiCourantParaJson.warning.email["idcompte_email_" + dataCompteEmail.id_compte_email].envoi_tracking_prevenir = !e.value
                                //                    option.bddCtrl.mSaveParaJsonUtilisateur();
                                //                }
                                //            })
                                //        }
                                //    }).dxCtrlTooltip("instance")
                                //    tt.show()
                                //} else {
                                //    mSendTracking()
                                //}

                                function mSendTracking() {
                                    if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                                        dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                                            option.data.tracking = "1"
                                            option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () {
                                                dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 8)
                                            })
                                        }, option.bddCtrl.getObjet(option.data).cle() == null)
                                    } else {
                                        option.data.tracking = "1"
                                        option.bddCtrl.getObjet(option.data).mSaveChamp("tracking", function () {
                                            dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 8)
                                        })
                                    }
                                }

                            }
                        }
                        $("<div/>").appendTo(itemElement).dxCtrlButton(opt);

                    },
                })
            }
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                visible: !parametre.isMobile,
                template(itemData, itemIndex, itemElement) {
                    var opt = {
                        icon: "fas fa-paper-plane",
                        icon2: "fas fa-vial",
                        colorIcone2: theme.colorBtIcon2,
                        opacityIcone2: "0.9",
                        txtTooltip: "Tester votre message en l'envoyant<br/>sur des adresses emails saisies.",
                        //text: "Tester l'email",
                        width: "100%",
                        onClick: function (e) {
                            $("<div/>").appendTo("body").dxCtrlPopupSaisieEmailTest({
                                bddCtrl: option.bddCtrl,
                                onValidate: function (lstEmail) {
                                    jauge.mShow();
                                    jauge.option("message", "Génération et envoi du mail de test")

                                    if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                                        dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                                            mTest()
                                        }, option.bddCtrl.getObjet(option.data).cle() == null)
                                    } else { mTest() }
                                    function mTest() {
                                        option.bddCtrl.getObjet("com_email_envoi", option.data.id_com_email_envoi).objetMetier.mSendEmailTest(lstEmail, function () {
                                            jauge.mHide();
                                            if (option.bddCtrl.isDemo) {
                                                mNotify("Vous êtes dans un environnement de démo<br/>L'envoi de votre email a été simulé et celui-ci n'a pas été réellement envoyé", "warning", 6000)
                                            } else {
                                                mNotify("Votre email de test a été envoyé.", "success", 6000)
                                            }
                                        })
                                    }
                                }
                            })
                        },
                        onContentReady: function (e) { e.component.element().find(".dx-button-content").css("flex", "none") }
                    }
                    $("<div/>").appendTo(itemElement).dxCtrlButton(opt);
                },
            })
            itemsToolbar.push(getToolbarSeparator())
        }
        if (parseInt(option.data.id_type_classement) == 8) {
            itemsToolbar.push(getToolbarSeparator())
            itemsToolbar.push({
                location: 'after',
                locateInMenu: 'auto',
                visible: !parametre.isMobile,
                template(itemData, itemIndex, itemElement) {
                    $("<div/>").appendTo(itemElement).dxCtrlButton({
                        icon: "fas fa-paper-plane",
                        icon2: "fas fa-share",
                        colorIcone2: theme.colorBtIcon2,
                        opacityIcone2: "0.9",
                        txtTooltip: "Envoyer immédiatement",
                        onClick: function (e) {
                            if (typeof dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase != 'undefined') {
                                dxContentEmailEnvoiNormalTracking.mGetDxContentEmailBase().mSaveAuto(function () {
                                    option.data.date_envoi = parametre.dateNow
                                    option.bddCtrl.getObjet(option.data).mSave()
                                    dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 13)
                                    ////option.data.id_type_classement = 13
                                    //page.mRemovePopup(option.data)
                                }, option.bddCtrl.getObjet(option.data).cle() == null)
                            } else {
                                option.data.date_envoi = parametre.dateNow
                                option.bddCtrl.getObjet(option.data).mSave()
                                dxContentEmailEnvoiNormalTracking.mSendEmail(e.component.element(), true, true, 13)
                                //option.data.id_type_classement = 13
                                page.mRemovePopup(option.data)
                            }
                        }
                    });
                },
            })
            itemsToolbar.push(getToolbarSeparator())
        }
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Mettre à la corbeille",
                    onClick: function (e) {
                        if (typeof option.optionPopup.onDelete != 'undefined') option.optionPopup.onDelete()
                        option.bddCtrl.getObjet(option.data).mDelData()
                        page.mRemovePopup(option.data)
                        //var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                        //    target: e.component.element(),
                        //    contentTemplate: function (contentElement) {
                        //        contentElement.css("padding", "25px")
                        //        $("<div style='padding-bottom:15px;'>Mettre le message<br/>à la corbeille</div>").appendTo(contentElement)
                        //        $("<div/>").appendTo(contentElement).dxCtrlButton({
                        //            text: "Confirmez",
                        //            onClick: function (e) {
                        //                tt.hide()
                        //                if (typeof option.optionPopup.onDelete != 'undefined') option.optionPopup.onDelete()
                        //                option.bddCtrl.getObjet(option.data).mDelData()
                        //                page.mRemovePopup(option.data)
                        //            }
                        //        })
                        //    }
                        //}).dxCtrlTooltip("instance");
                        //tt.show();
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)

        mRempliTaille()
    }

    function mRempliTaille() {
        eleTaille.empty()
        eleTaille.css("text-align", "right")
        var $SpanClickVue = $("<span></span>").appendTo(eleTaille)
        option.bddCtrl.mAjaxCall({
            command: "getresumeenvoi",
            id_table_com: option.bddCtrl.getObjet(option.data).mGetTable().id_table,
            id_com: option.bddCtrl.getObjet(option.data).cle()
        }, function (data) {
            data = data.stat[0]
            if (data.nb_vue > 0) {
                var $Span = $("<div><i class='fas fa-eye'></i> (" + data.nb_vue + ") " + data.date_vue.toDateIlya(true) + "</div>").appendTo($SpanClickVue)
                $Span.attr("title", data.nb_vue + " vue" + ((data.nb_vue > 1) ? "s" : "") + "<br/>Dernière vue le " + data.date_vue.toFrenchDateTime())
            }
            if (data.nb_click > 0) {
                var $Span = $("<div><i class='fas fa-arrow-pointer'></i> (" + data.nb_click + ") " + data.date_click.toDateIlya(true) + "</div>").appendTo($SpanClickVue)
                $Span.attr("title", data.nb_click + " click" + ((data.nb_click > 1) ? "s" : "") + "<br/>Dernier click le " + data.date_click.toFrenchDateTime())
            }
        })
        if (option.data.heberger_image == "1") {
            var $Span = $("<div style='" + ((option.data.taille_octet_ss_image == 0) ? "display:none;" : "") + "'>" + option.data.taille_octet_ss_image.sizeFile(2, true) + "</div>").appendTo(eleTaille)
            if (option.data.taille_octet_ss_image.sizeFile(2) != option.data.taille_octet.sizeFile(2)) $Span.attr("title", "Poids message: " + option.data.taille_octet_ss_image.sizeFile(2, true) + "<br/>" + "(Avec image: " + option.data.taille_octet.sizeFile(2, true) + ")")
        } else {
            var $Span = $("<div style='" + ((option.data.taille_octet == 0) ? "display:none;" : "") + "'>" + option.data.taille_octet.sizeFile(2, true) + "</div>").appendTo(eleTaille)
            if (option.data.taille_octet_ss_image.sizeFile(2) != option.data.taille_octet.sizeFile(2)) $Span.attr("title", "Poids message: " + option.data.taille_octet.sizeFile(2, true) + "<br/>" + "(Sans image: " + option.data.taille_octet_ss_image.sizeFile(2, true) + ")")
        }

    }

    function mRempliDate() {
        //$DivDat.fadeOut(200, function () {
        eleDateEnvoi.empty()
        var datDetail = option.bddCtrl.getObjet(option.data).objetMetier.mGetDateEtLib()
        //eleDateEnvoi.html(datDetail.lib)
        //$DivDat.fadeIn(200)
        eleDateEnvoi.attr("title", "")
        //if (datDetail.canCancel) {
        //    eleBtAnnuelEnvoi.show()
        //    eleDateEnvoi.attr("title", "Sera envoyé dans " + datDetail.dateEnvoi.toDateIlya(false, true))
        //} else {
        //    eleBtAnnuelEnvoi.hide()
        //}
        if (datDetail.enCoursEnvoi) {
            $("<img src='" + parametre.urldispatch + "/img/jauge2.svg' style='width:18px;'/>").appendTo(eleDateEnvoi)
            if (eleDateEnvoi.attr("title").length == 0) eleDateEnvoi.attr("title", "En cours d'envoi")
        } else if (datDetail.dateEnvoi) {
            $("<span>" + datDetail.dateEnvoi.toDateIlya(true, true) + "</span>").appendTo(eleDateEnvoi)
            var smtpNom = ""
            switch (parseInt(option.data.id_type_smtp_encours)) {
                case 1: smtpNom = "<span style='color:green'>SMTP adresse email (" + option.data.id_type_smtp_encours + ")</span>"; break;
                case 2: smtpNom = "<span style='color:green'>SMTP " + parametre.nom + " emailing (" + option.data.id_type_smtp_encours + ")</span>"; break;
                case 3: case 9: smtpNom = "<span style='color:red'>SMTP dégradé (" + option.data.id_type_smtp_encours + ")</span>"; break;
                case 4: smtpNom = "<span style='color:orange'>SMTP " + parametre.nom + " quotidien (" + option.data.id_type_smtp_encours + ")</span>"; break;
                case 10: smtpNom = "<span style='color:green'>SMTP domaine dédié client (" + option.data.id_type_smtp_encours + ")</span>"; break;
                default: smtpNom = "<span style='color:gray'>SMTP type " + option.data.id_type_smtp_encours + " (" + option.data.id_type_smtp_encours + ")</span>"; break;
            }
            if (eleDateEnvoi.attr("title").length == 0) eleDateEnvoi.attr("title", "Envoyé le " + datDetail.dateEnvoi.toFrenchDateTime() + "<br/>" + smtpNom)
        }

        if (datDetail.canCancel || datDetail.enCoursEnvoi) {
            window.setTimeout(function () {
                if (container.closest("body").length == 0) return
                mRempliDate()
            }, 2000)
        }
    }

    this.element = function () { return container }

    //this.dispose = function () {
    //    if (dxContentEmailEnvoiNormalTracking) dxContentEmailEnvoiNormalTracking.dispose()
    //}

    mConstruit();
}